<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="success" plain @click="onExport" v-if="$permission.canExport()">导出</el-button>
        <el-button size="mini" type="primary" @click="create">创建</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{row}">
            <el-button type="text" @click="details(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <detail-dialog ref="detailDialog" @close-saved="reload" />
    <create-dialog ref="createDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/mall/worder/all/list";
import detailDialog from "@/components/mall/worder/all/detailDialog";
import createDialog from "@/components/mall/worder/all/createDialog";

export default {
  name: "worder_all",
  mixins: [curdMixins],
  components: {
    list,
    detailDialog,
    createDialog,
  },
  methods: {
    details(row) {
      this.$refs.detailDialog.openDetails(row);
    },
    create() {
      this.$refs.createDialog.openCreate();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
  },
};
</script>